import type { PreProcessor } from 'api/requestUtils'
import type { AppStore } from 'src/client/store'

export default function localeLoader(store: AppStore): PreProcessor {
  return (params) => {
    const locale = store.getState().geo.locale
    if (locale) {
      params.options.headers = {
        ...params.options.headers,
        'Accept-Language': locale,
      }
    }
    return params
  }
}
